import { searchUserGQL, PublicUser } from "@onmo/graphql/legacyGraphql";
import { meGQL } from "../../graphql";
import { useStyles } from "./SearchVideo.style";
import { useMemo, useState } from "react";
import { useLegacyQuery } from "@onmo/graphql/legacyGraphql";
import { Icon } from "../../components/core/Icon/Icon";
import { TextField } from "../../components/core/TextField";
import { debounce } from "lodash";
import { Typography } from "../../components/core/Typography/Typography";
import { TypographyColor, TypographyVariant } from "../../constants/typography";
import { HistoryGaming } from "../../models/historyGaming";
import { useQuery } from "@apollo/client";
import { useNavigate } from "react-router-dom";

const SearchFriends: React.FC = () => {
  const classes = useStyles();
  const navigate = useNavigate();

  const [query, setQuery] = useState<string>();
  const { data } = useLegacyQuery(searchUserGQL, {
    variables: { searchUsersInput: { username: query } },
    skip: !query || query?.length < 3,
  });
  const { data: dataMe } = useQuery(meGQL);

  const debouncedOnChangeQuery = debounce((query: string) => {
    setQuery(query);
  }, 500);

  const searchResult = useMemo(() => {
    if (!data?.users?.items?.length) return data?.users?.items;

    return data?.users?.items?.filter((item: PublicUser) => {
      return item.id !== dataMe?.me?.id;
    });
  }, [data, dataMe]);

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <Icon
          name="icon-bold-arrow-left-3"
          onClick={() => HistoryGaming.back(navigate)}
          size={24}
          className={classes.icon}
        />
        <TextField
          startIcon={
            <Icon
              name="icon-linear-search-normal"
              className={classes.searchIcon}
            />
          }
          fullWidth
          inputProps={{
            placeholder: "Search Video",
          }}
          isShowClear
          onChangeValue={debouncedOnChangeQuery}
        />
      </div>
      <div className={classes.container}>
        {!searchResult?.length ? (
          <div className={classes.noResult}>
            <Typography variant={TypographyVariant.HeadingH5Bold}>
              {query && query?.length >= 3
                ? `Couldn't find “${query}”`
                : "Search Video"}
            </Typography>
            <Typography
              variant={TypographyVariant.BodyB5Regular}
              color={TypographyColor.Silver}
            >
              {query && query?.length >= 3
                ? "Search Video"
                : "Search video name or category, please enter at least 3 characters to search"}
            </Typography>
          </div>
        ) : (
          <div></div>
        )}
      </div>
    </div>
  );
};

export default SearchFriends;
